import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  model,
  signal,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CompanyInterface } from '@app/interface/company';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DialogData } from '@app/new-company/new-company.component';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'izy-confirm-invoice-upload-xml',
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatSnackBarModule,
    MatSelectModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatIconModule,
  ],
  standalone: true,
  templateUrl: './confirm-invoice-upload-xml.component.html',
  styleUrl: './confirm-invoice-upload-xml.component.scss',
})
export class ConfirmInvoiceUploadXmlComponent {
  confirmed = false;

  constructor(
    public dialogRef: MatDialogRef<ConfirmInvoiceUploadXmlComponent>
  ) {}

  confirm(): void {
    this.dialogRef.close(true);
  }

  legalConditionsRedirect() {
    window.open('https://www.beizy.it/legal', '_blank');
  }
}
